import React, { useRef, useState } from "react";

// img
import p1 from "../../images/samandehi.png";
import p2 from "../../images/enamad.png";

import free from "../../images/free.png";
// import money from "../../images/money.png";
import pay from "../../images/pay.png";
import garanti from "../../images/garanti.png";
import support from "../../images/support.png";

import Input from "../../components/shared/Form/Input";

import { toFarsiNumber } from "../../helper/helper";
import { postData } from "../../services/API";
import { useForm } from "react-hook-form";
import Loading from "../shared/Loading";
import CircleLoading from "../shared/CircleLoading";
import { Toast } from "primereact/toast";
import { Link, useLocation } from "react-router-dom";
import license from "../../images/digital-license.png";
import license1 from "../../images/digital-license1.png";

// /support/contact-admin-list
const Footer = () => {
  const { register, getValues, setValue } = useForm();
  const [newsletterLoading, setNewsletterLoading] = useState(false);
  const [contactLoading, setContactLoading] = useState(false);
  const [errMsg, setErrMsg] = useState([]);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  const newsletterSucc = useRef(null);
  const newsletterFail = useRef(null);
  const contactSucc = useRef(null);
  const contactFail = useRef(null);

  const newsletterSubmit = () => {
    if (email) {
      setNewsletterLoading(true);
      postData("/support/newsletter", { email })
        .then((res) => {
          setEmail("");
          setNewsletterLoading(false);

          newsletterSucc.current.show({
            severity: "success",
            summary: "عضویت با موفقیت انجام شد",
            detail: "شما در خبرنامه یونی بست عضو شدید.",
            life: 3500,
          });
        })
        .catch((err) => {
          setErrMsg(err.response.data);
          setNewsletterLoading(false);
          newsletterFail.current.show({
            severity: "error",
            summary: "خطا هنگام عضویت در خبرنامه",
            detail: err.response.data.message,
            life: 3500,
          });
        });
    }
  };

  const contactSubmit = () => {
    if (phoneNumber && name) {
      setContactLoading(true);
      postData("/support/contact-admin", {
        phone_number: phoneNumber,
        name,
      })
        .then((res) => {
          setValue("phone_number", "");
          setValue("name", "");
          setContactLoading(false);

          contactSucc.current.show({
            severity: "success",
            summary: "درخواست با موفقیت ثبت شد",
            detail: "منتظر تماس پشتیبانی یونی بست باشید.",
            life: 3500,
          });
        })
        .catch((err) => {
          setErrMsg(err.response.data);
          setContactLoading(false);
          contactFail.current.show({
            severity: "error",
            summary: "خطا هنگام ثبت درخواست",
            detail: err.response.data.message,
            life: 3500,
          });
        });
    }
  };

  return (
    <footer className="w-full flex flex-col items-center gap-3 mt-28 px-3 2xl:px-0">
      <Toast ref={newsletterSucc} />
      <Toast ref={newsletterFail} />
      <Toast ref={contactSucc} />
      <Toast ref={contactFail} />

      <div className="flex flex-col gap-6 w-full max-w-[1300px] pb-5">
        <div className="flex items-center justify-between lg:flex-row flex-col gap-6 bg-[#222222] p-6 rounded-xl h-auto">
          <div className="w-full lg:w-auto flex flex-col gap-3 p-6 bg-gradient-to-tl from-yellow-900 to-yellow-500 pl-10 rounded-lg">
            <div className="flex text-white items-center gap-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="w-5 h-5 fill-white"
              >
                <path
                  fillRule="evenodd"
                  d="M1.5 4.5a3 3 0 0 1 3-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 0 1-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 0 0 6.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 0 1 1.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 0 1-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z"
                  clipRule="evenodd"
                />
              </svg>

              <span>{toFarsiNumber("02191690923")}</span>
            </div>

            <div className="flex text-white items-center gap-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="w-5 h-5 fill-white"
              >
                <path d="M19.5 22.5a3 3 0 0 0 3-3v-8.174l-6.879 4.022 3.485 1.876a.75.75 0 1 1-.712 1.321l-5.683-3.06a1.5 1.5 0 0 0-1.422 0l-5.683 3.06a.75.75 0 0 1-.712-1.32l3.485-1.877L1.5 11.326V19.5a3 3 0 0 0 3 3h15Z" />
                <path d="M1.5 9.589v-.745a3 3 0 0 1 1.578-2.642l7.5-4.038a3 3 0 0 1 2.844 0l7.5 4.038A3 3 0 0 1 22.5 8.844v.745l-8.426 4.926-.652-.351a3 3 0 0 0-2.844 0l-.652.351L1.5 9.589Z" />
              </svg>

              <span>info@myunibest.ir</span>
            </div>

            <div className="flex text-white items-center gap-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="min-w-5 h-5 fill-white"
              >
                <path
                  fillRule="evenodd"
                  d="m11.54 22.351.07.04.028.016a.76.76 0 0 0 .723 0l.028-.015.071-.041a16.975 16.975 0 0 0 1.144-.742 19.58 19.58 0 0 0 2.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 0 0-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 0 0 2.682 2.282 16.975 16.975 0 0 0 1.145.742ZM12 13.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
                  clipRule="evenodd"
                />
              </svg>

              <span>
                میدان ونک، ابتدای حقانی، نرسیده به چهارراه جهان کودک، پلاک ۴۰
                مرکز نوآوری دانشگاه علامه طباطبایی طبقه چهارم، یونی بست
              </span>
            </div>
          </div>

          <div className="w-full grid grid-cols-2 md:grid-cols-4 gap-6 place-content-center justify-center">
            <div className="flex flex-col justify-center text-gray-300 gap-3 items-center">
              <img src={free} className="w-[50px] h-[50px]" alt="" />
              <span>اس اس ال</span>
            </div>

            <div className="flex flex-col justify-center text-gray-300 gap-3 items-center">
              <img src={support} alt="" />
              <span>پشتیبانی ۲۴ ساعته</span>
            </div>

            <div className="flex flex-col justify-center text-gray-300 gap-3 items-center">
              <img src={pay} alt="" />
              <span>پرداخت ایمن</span>
            </div>

            <div className="justify-center flex flex-col text-gray-300 gap-3 items-center">
              <img src={garanti} alt="" />
              <span>تضمین کیفیت خدمات</span>
            </div>
          </div>
        </div>

        <div className="w-full md:h-20 bg-[#222222] flex flex-col gap-4 md:flex-row justify-between items-center lg:p-6 p-4 rounded-xl">
          <h3 className="text-gray-300 font-black text-xl">عضویت در خبرنامه</h3>

          <div className="w-full lg:w-auto flex items-center flex-col md:flex-row gap-3">
            <Input
              element={"input"}
              placeHolder={"ایمیل شما"}
              wrapperClass={"lg:!w-96"}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              error={errMsg["email"] && errMsg["email"]}
            />
            <button
              onClick={newsletterSubmit}
              className="flex justify-center text-white items-center w-full md:w-auto bg-gradient-to-tl from-green-600 to-green-300 h-[50px] px-6 rounded-xl"
            >
              {newsletterLoading ? <CircleLoading /> : "عضویت"}
            </button>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-6 xl:grid-cols-4">
          <div className="flex flex-col gap-2">
            <div className="flex gap-2 items-center">
              <span className="block w-3 h-1 rounded-full bg-yellow-700"></span>
              <h3 className="text-xl text-gray-200">برند ها</h3>
            </div>
            <ul className="flex flex-col gap-2">
              <li className="text-gray-300 flex items-center gap-3">
                <span className="block w-1 h-1 rounded-full bg-yellow-300"></span>
                <a href="https://www.udemy.com/">یودمی</a>
              </li>
              <li className="text-gray-300 flex items-center gap-3">
                <span className="block w-1 h-1 rounded-full bg-yellow-300"></span>
                <a href="https://www.linkedin.com/learning">لیندا</a>
              </li>
              <li className="text-gray-300 flex items-center gap-3">
                <span className="block w-1 h-1 rounded-full bg-yellow-300"></span>
                <a href="https://www.masterclass.com/">مستر کلاس</a>
              </li>
              <li className="text-gray-300 flex items-center gap-3">
                <span className="block w-1 h-1 rounded-full bg-yellow-300"></span>
                <a href="https://www.coursera.org/">کورسرا</a>
              </li>
            </ul>
          </div>

          <div className="flex flex-col gap-2">
            <div className="flex gap-2 items-center">
              <span className="block w-3 h-1 rounded-full bg-yellow-700"></span>
              <h3 className="text-xl text-gray-200">دسترسی سریع</h3>
            </div>
            <ul className="flex flex-col gap-2">
              <li className="text-gray-300 flex items-center gap-3">
                <span className="block w-1 h-1 rounded-full bg-yellow-300"></span>
                <Link to={"/"}>صفحه اصلی</Link>
              </li>
              <li className="text-gray-300 flex items-center gap-3">
                <span className="block w-1 h-1 rounded-full bg-yellow-300"></span>
                <Link to={"/shop"}>فروشگاه</Link>
              </li>
              <li className="text-gray-300 flex items-center gap-3">
                <span className="block w-1 h-1 rounded-full bg-yellow-300"></span>
                <Link to={"/courses"}>آموزشگاه</Link>
              </li>
              <li className="text-gray-300 flex items-center gap-3">
                <span className="block w-1 h-1 rounded-full bg-yellow-300"></span>
                <Link to={"/news"}>اخبار یونی بست</Link>
              </li>
              <li className="text-gray-300 flex items-center gap-3">
                <span className="block w-1 h-1 rounded-full bg-yellow-300"></span>
                <Link to={"/about-us"}>درباره ما</Link>
              </li>

              <li className="text-gray-300 flex items-center gap-3">
                <span className="block w-1 h-1 rounded-full bg-yellow-300"></span>
                <Link to={"/contact-us"}>تماس با ما</Link>
              </li>

              <li className="text-gray-300 flex items-center gap-3">
                <span className="block w-1 h-1 rounded-full bg-yellow-300"></span>
                <Link to={"/faq"}>سوالات متداول</Link>
              </li>
            </ul>
          </div>

          <div className="flex flex-col items-center col-span-2 md:col-span-1 gap-2">
            <div className="flex gap-2 items-center">
              <span className="block w-3 h-1 rounded-full bg-yellow-700"></span>
              <h3 className="text-xl text-gray-200">نماد های ما</h3>
            </div>

            <div className="grid grid-cols-2 gap-4">
              {window.location.hostname === "myunibest.ir" ? (
                <a
                  referrerPolicy="origin"
                  target="_blank"
                  href="https://trustseal.enamad.ir/?id=581103&Code=nxUtsRIR3Smy6puOM0wGLqEeJkuPTpuR"
                >
                  <img
                    referrerPolicy="origin"
                    src="https://trustseal.enamad.ir/logo.aspx?id=581103&Code=nxUtsRIR3Smy6puOM0wGLqEeJkuPTpuR"
                    alt=""
                    className="w-[125px]"
                    code="nxUtsRIR3Smy6puOM0wGLqEeJkuPTpuR"
                  />
                </a>
              ) : (
                <a
                  referrerpolicy="origin"
                  target="_blank"
                  href="https://trustseal.enamad.ir/?id=487874&Code=PKSZsFV1S9jqTMIsSJvgPAD6oIIBd9B6"
                >
                  <img
                    referrerpolicy="origin"
                    src="https://trustseal.enamad.ir/logo.aspx?id=487874&Code=PKSZsFV1S9jqTMIsSJvgPAD6oIIBd9B6"
                    alt=""
                    className="w-[125px]"
                    code="PKSZsFV1S9jqTMIsSJvgPAD6oIIBd9B6"
                  />
                </a>
              )}

              <a
                referrerpolicy="origin"
                target="_blank"
                href="https://eanjoman.ir/member/xkZHtHqJZAZQct0UT0Dre0knY"
              >
                <img
                  src="https://eanjoman.ir/api/script?code=xkZHtHqJZAZQct0UT0Dre0knY"
                  alt="انجمن صنفی کارفرمایی فروشگاه های اینترنتی شهر تهران(کسب و کار های اینترنتی)"
                  title="انجمن صنفی کارفرمایی فروشگاه های اینترنتی شهر تهران(کسب و کار های اینترنتی)"
                  className="w-[125px] h-[136px] object-contain"
                />
              </a>

              <a
                href="https://myunibest.ir/images/digital-license.jpg"
                target="_blank"
              >
                <img
                  src={license}
                  className="w-[110px] rounded-xl"
                  alt="مجز نشر دیجیتال وزارت فرهنگ و ارشاد اسلامی"
                  title="مجز نشر دیجیتال وزارت فرهنگ و ارشاد اسلامی"
                />
              </a>

              <a
                href="https://myunibest.ir/images/fani-license.pdf"
                target="_blank"
              >
                <img
                  src={license1}
                  className="w-[125px] rounded-xl"
                  alt="مجز نشر فنی و حرفه ای"
                  title="مجز نشر فنی و حرفه ای"
                />
              </a>
            </div>
          </div>

          <div className="flex flex-col col-span-2 md:col-span-3 xl:col-span-1 gap-4">
            <div className="w-full h-14 p-4 text-lg bg-[#222] rounded-xl flex justify-center items-center">
              <div className="w-full flex flex-row-reverse items-center justify-between">
                <div className="telegram-icon"></div>

                <div className="instagram-icon"></div>

                <div className="twitter-icon"></div>

                <div className="aparat-icon"></div>

                <div className="facebook-icon"></div>
              </div>
            </div>

            <div className="flex flex-col mb-4 lg:mb-0 gap-2">
              <div className="flex gap-2 items-center">
                <span className="block w-3 h-1 rounded-full bg-yellow-700"></span>
                <h3 className="text-xl text-gray-200">درخواست پشتیبانی</h3>
              </div>

              <div className="flex flex-col items-center gap-2">
                <Input
                  element={"input"}
                  placeHolder={"نام شما"}
                  className={"!bg-[#222222]"}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  error={errMsg["name"] && errMsg["name"]}
                />
                <Input
                  element={"input"}
                  placeHolder={"شماره تلفن"}
                  className={"!bg-[#222222]"}
                  value={phoneNumber}
                  onChange={(e) => {
                    const onlyNum = /^[0-9\b]+$/;

                    if (e.target.value === "" || onlyNum.test(e.target.value)) {
                      setPhoneNumber(e.target.value);
                    }
                  }}
                  error={errMsg["phone_number"] && errMsg["phone_number"]}
                />
              </div>
              <button
                onClick={contactSubmit}
                className="w-full h-11 rounded-xl bg-gradient-to-tl from-green-600 to-green-300 text-white flex items-center justify-center"
              >
                {contactLoading ? (
                  <CircleLoading color={"before:!bg-[#222222]"} />
                ) : (
                  "ثبت درخواست"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-center items-center h-14 w-full bg-[#222222]">
        <span className="text-lg font-black text-yellow-700">یونی بست</span>
      </div>
    </footer>
  );
};

export default Footer;
{
  /* <div className="flex flex-col gap-2 items-center">
    //         <div className="flex flex-row-reverse items-center gap-2">
    //           <h3 className="text-lg font-black text-blue-600">شبکه نفیس</h3>
    //           <span className="block w-3 h-1 rounded-full bg-blue-500"></span>
    //         </div>
    //         <ul className="flex flex-col items-center gap-1">
    //           <li className="text-sm text-gray-600">
    //             <a href="#">اهداف</a>
    //           </li>
    //           <li className="text-sm text-gray-600">
    //             <a href="#">چرا نفیس</a>
    //           </li>
    //           <li className="text-sm text-gray-600">
    //             <a href="#">طرح درآمدزایی</a>
    //           </li>
    //           <li className="text-sm text-gray-600">
    //             <a href="#">قوانین و مقررات</a>
    //           </li>
    //           <li className="text-sm text-gray-600">
    //             <a href="#">قوانین داخلی</a>
    //           </li>
    //         </ul>
    //       </div> */
}
